<template>
    <div v-if="availableLocales" class="p-4">
        <div class="mb-4">
            <div v-show="!showInput">
                <!-- Show the button when the locale is set -->
                <button
                    class="w-64 p-2 border rounded cursor-pointer"
                    @click="toggleInput"
                >
                    {{ selectedLocale }}
                </button>
            </div>
            <div v-show="showInput">
                <div class="grid m-2">
                    <label
                        for="locales"
                        class="block mb-2 text-sm font-medium text-gray-900"
                        >Locale</label
                    >
                    <select
                        id="locales"
                        v-model="selectedLocale"
                        placeholder="Enter Locale (e.g., en_PK, fr_FR)"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-lg leading-8 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5"
                        @change="updateLocale"
                    >
                        <template
                            v-for="(availableLocale, index) in availableLocales"
                            :key="index"
                        >
                            <option
                                :value="availableLocale"
                                :selected="availableLocale === selectedLocale"
                            >
                                {{ availableLocale }}
                            </option>
                        </template>
                    </select>
                </div>

                <!-- Show the input field when the locale is not set -->
                <!--                <input-->
                <!--                    ref="localeInput"-->
                <!--                    v-model="selectedLocale"-->
                <!--                    class="w-64 p-2 border rounded"-->
                <!--                    type="text"-->
                <!--                    placeholder="Enter Locale (e.g., en_PK, fr_FR)"-->
                <!--                    @blur="updateLocale"-->
                <!--                    @click="selectText"-->
                <!--                />-->
            </div>
        </div>

        <div v-if="showTariffTool">
            <!-- Display the TariffToolMain component with the selected locale as a prop -->
            <TariffToolMain :locale="selectedLocale" />
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import TariffToolMain from './TariffToolMain.ce.vue';
import { useApiResponsesStore } from '@/store/responses';
import { storeToRefs } from 'pinia';
import { tariffsService } from '@/services/tariffs';

export default {
    components: {
        TariffToolMain,
    },
    setup() {
        const selectedLocale = ref(
            localStorage.getItem('selectedLocale') || ''
        );
        const showTariffTool = ref(false);
        const showInput = ref(!selectedLocale.value); // Hide input initially if locale is set

        // Create a ref for the input element
        const localeInput = ref(null);

        const apiResponsesStore = useApiResponsesStore();
        const { countryResponses } = storeToRefs(apiResponsesStore);
        let availableLocales = ref([]);
        tariffsService
            .availableLocales(countryResponses.value.numericCode)
            .then((response) => {
                availableLocales.value = response;
            });

        const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

        const updateLocale = async () => {
            const regexPattern = /^[a-z]{2}_[a-zA-Z]{2}$/; // Regular expression for xx_YY format
            const previousLocale = localStorage.getItem('selectedLocale');

            console.log('previousLocale', previousLocale);
            console.log('selectedLocale.value', selectedLocale.value);

            if (selectedLocale.value === previousLocale) {
                // Value has not changed, no need to do anything
                showInput.value = false; // Hide the input after setting the locale
                return;
            }

            if (regexPattern.test(selectedLocale.value)) {
                showTariffTool.value = false; // Set showTariffTool to false temporarily
                showInput.value = false; // Hide the input after setting the locale

                // wait for next tick delay, set showTariffTool back to true
                await sleep(1);
                showTariffTool.value = true;
            } else {
                // Invalid format, reset the selectedLocale and hide TariffToolMain
                localStorage.removeItem('selectedLocale');
                selectedLocale.value = '';
                showTariffTool.value = false;
            }
        };

        const toggleInput = async () => {
            showInput.value = !showInput.value;
            if (showInput.value && localeInput.value) {
                // Wait for the next tick to ensure the element is in the DOM before focusing
                await sleep(1);
                localeInput.value.focus();
                localeInput.value.select();
            }
        };

        // Check if a locale is already set in local storage on component mount
        onMounted(() => {
            showTariffTool.value = !!selectedLocale.value;
            showInput.value = !selectedLocale.value;
        });

        return {
            availableLocales,
            selectedLocale,
            showTariffTool,
            showInput,
            updateLocale,
            toggleInput,
            localeInput,
        };
    },
};
</script>
